import { useState, useEffect } from "react";

export default function useScroll(type, value) {
  const [isScrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = (e) => {
      var scrollPosY = window.pageYOffset | document.body.scrollTop;
      switch (type) {
        case ">":
          return setScrolled(scrollPosY > value);
        default:
          return setScrolled(scrollPosY < value);
      }
    };
    document.addEventListener("scroll", handleScroll, { passive: true });
    return () => {
      document.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return isScrolled;
}
